import {
  AddOutlineMediumIcon,
  CardButtonSmallRounded,
  CardNavigation,
  Section,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { LinkProps } from 'next/link';
import { ElementType, useId } from 'react';
import { StyledGroupElementScroll } from './StyledGroupElementScroll';

export type Item = {
  icon: ElementType<{ color: string }>;
  label: string;
  link: LinkProps['href'];
  tag?: string;
};

type ProductSectionProps = {
  color: string;
  product: Item;
  items: Item[];
};

export const ProductSection = (props: ProductSectionProps) => {
  const id = useId();

  return (
    <Section>
      <LinkWrapper href={props.product.link}>
        <CardNavigation
          title={props.product.label}
          icon={<props.product.icon color={props.color} />}
        />
      </LinkWrapper>

      <StyledGroupElementScroll>
        {props.items?.map(({ icon: Icon, label, link, tag }) => {
          return (
            <LinkWrapper href={link} key={`${id}-${label}`}>
              <CardButtonSmallRounded
                icon={<Icon color={props.color} />}
                label={label}
                tagContent={tag}
              />
            </LinkWrapper>
          );
        })}
        <LinkWrapper href={props.product.link}>
          <CardButtonSmallRounded
            icon={<AddOutlineMediumIcon color={props.color} />}
            label="Ver mais"
          />
        </LinkWrapper>
      </StyledGroupElementScroll>
    </Section>
  );
};
